import React from 'react'
import { FormattedMessage } from 'react-intl'
import Image from '../../../components/Image'
import { ReactComponent as LinkedInIcon } from '../../../assets/icons/linkedIn.svg'

export interface TeamMember {
  slug: string
  name: string
  position?: string
  linkedIn: string
}

interface TeamGridProps {
  data: TeamMember[]
}

const TeamGrid = ({ data }: TeamGridProps) => {
    return (
        <div className='flex flex-wrap md:grid grid-cols-3 justify-center border-y border-black/10'>
            {data.map((member) => (
                <div className='team-grid' key={member.name}>
                    <div className='relative'>
                        <a href={member.linkedIn} target='_blank' rel='noopener noreferrer'>
                            <div className='aspect-square'>
                                <Image
                                    alt={member.name}
                                    slug={member.slug}
                                    className='object-cover aspect-square w-40 object-top'
                                />
                            </div>

                            <LinkedInIcon className='w-4 h-4 absolute top-0 right-0 m-2 md:m-4' />
                        </a>
                    </div>
                    <p className='opacity-100 pt-6 text-base'>{member.name}</p>
                    {member.position && (
                        <h6 className='text-xs text-black/40 uppercase pt-2'>
                            <FormattedMessage id={member.position} />
                        </h6>
                    )}
                </div>
            ))}
        </div>
    )
}

export default TeamGrid
